<template>
    <!-- Фільтр на категорію проєктів -->
    <div class="mb-4 border-top mt-3 pt-3" >
        <label
            for="status-select"
            class="form-label fs-15 text-success text-uppercase fw-semibold mb-3"
            >{{ $t('Categories') }}</label
        >
        <br />
        <div class="row g-2 list_filtr" >
            <div class="col-lg-6">
                <div class="form-check mb-2" >
                    <input class="form-check-input" type="radio" @change="change()" name="radioCategory" id="all_categories" v-model="category" :value="''">
                    <label class="form-check-label" for="all_categories">{{ $t('all') }}</label>
                </div>
            </div>
            <template v-for="(value, index) in opt" :key="index" >
                <div class="col-lg-6">
                    <div class="form-check mb-2" >
                        <input class="form-check-input" type="radio" @change="change()" name="radioCategory" :id="'category'+index" v-model="category" :value="value.value">
                        <label class="form-check-label" :for="'category'+index">{{ value.name }}</label>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { storeS } from '../../../../store'

export default {
    data(){
        return {
            category: "",
            opt: [
                {   value: 'Content',
                    name: this.$t('contentPr') // контент
                },
                {
                    value: 'Development',
                    name: this.$t('development') // розробка
                }
            ]
        }
    },
    props: ['user'],
    created() {
        // Тут піклуємося про юзера і ставимо фільтр в залежності від його ролі, якщо нема повного доступу
        if(this.users.workerJob == 'developer' && this.users.perms[2000] != true) {
            this.opt = [{
                    value: 'Development',
                    name: this.$t('development')
                }]
        } else if(this.users.workerJob == 'smm' && this.users.perms[2000] != true) {
            this.opt=[{
                    value: 'Development',
                    name: this.$t('development')
                }]
        }
    },
    methods: {
        change(){
            this.$emit('change', 'category', this.category)
        },
    },
    computed: {
        users() {
            return storeS.userbase
        }
    }
}
</script>